import { cn } from "../../lib/cn";

interface Props {
  className?: string;
  width?: number | string;
  height?: number | string;
}

/** Single shimmer primitive — accent-soft over bg-inset, see index.css. */
export function Skeleton({ className, width, height }: Props) {
  return (
    <div
      className={cn("skeleton", className)}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}
